// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { metachain as _metachain } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the metachain chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 571
 * Chain Name: MetaChain Mainnet
 * Default Block Explorer: https://explorer.metatime.com
 * Default RPC URL: https://rpc.metatime.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { metachain } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: metachain,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const metachain = createCommon({
	..._metachain,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
